import { clubfinderApi } from "~/utils/axios.util"

export interface Platform {
    PlatformId: number
    Naam: string
    StartDatum: string
    EindDatum: string
    Label: string
    NaamAfzender: string
    EmailAfzender: string
    TemplatePrefix: string
    Url: string
    Subaccount: string
    Bekostigingstype: number
    BekostigingstypeFlag: number
    Sportmomenten: boolean
    Reeksen: boolean
    MaximaalAantalDeelnames: boolean
    Preview: true
    Betaalmodule: number
    InclusiefAdministratiekosten: boolean
    Servicekosten: number
    Transactiekosten: number
    MinimaleKosten: number
    MaximaleKosten: number
    IsMandatory: boolean
    RetourneertKosten: boolean
    Activiteittype: number
    IsLocal: boolean
    IsSportSpecific: boolean
}
class PlatformRepository {
    async getPlatformData(platformId: number) {
        const response = await clubfinderApi.get<Platform>("/api/Platform", {
            params: {
                id: platformId
            }
        });
        
        return response.data;
    }

}

export default new PlatformRepository();

